export const CANDIDATE_ICON = 'CANDIDATE_ICON';
export const EMPLOYER_ICON = 'EMPLOYER_ICON';
export const EDUCATION_ICON = 'EDUCATION_ICON';
